import katex from "katex";
const options = { throwOnError: false };
export default function katexify(math, noLineBreak = true) {
    if (noLineBreak) {
        return katex.renderToString("{" + String(math) + "}", options);
    }
    else {
        return katex.renderToString(String(math), options);
    }
}
